import { render, staticRenderFns } from "./RegisterView.vue?vue&type=template&id=c982f870&scoped=true&"
import script from "./RegisterView.vue?vue&type=script&lang=js&"
export * from "./RegisterView.vue?vue&type=script&lang=js&"
import style0 from "./RegisterView.vue?vue&type=style&index=0&id=c982f870&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c982f870",
  null
  
)

/* custom blocks */
import block0 from "./RegisterView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports